<script>
import { ShowPageElementMixin } from "%/dynamic-component-editor/standard-pages/show-page/show-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "ShowGenre",
  elementPanelSettings: {
    displayName: "Genre",
    displayIcon: "material-symbols:tag",
    elementGroup: "show",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [ShowPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      if (Array.isArray(this.entity.genres) && this.entity.genres.length) {
        return this.entity.genres.join(", ");
      }
      return "";
    },
  },
};
</script>

